<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Editar Motorista</mat-card-title>
    </div>
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">
      Voltar
    </button>
    <button mat-flat-button class="btn-tg w-1/12" [disabled]="!checkForm() || loading" (click)="editDriver()">
      @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
      Salvar
      }
    </button>
    <!--    <button class="btn-icon" (click)="close()">-->
    <!--      <mat-icon>close</mat-icon>-->
    <!--    </button>-->
  </mat-card-header>

  <div class="mt-4 mb-2"></div>
  <mat-card class="card-style px-6 pb-6">
    <div [formGroup]="formEmployee">
      <h4>Motorista</h4>
      <div>
        <div class="flex justify-between gap-4 items-center">
          <mat-form-field class="input-tg w-3/12" appearance="outline">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="typeDriver">
              @for (item of listTypeDriver; track item) {
              <mat-option [value]="item.id">{{
                item.description
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select formControlName="statusEmployee">
              @for (item of listStatusEmployee; track item) {
              <mat-option [value]="item.id">{{
                item.description
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg w-3/12" appearance="outline">
            <mat-label>Matrícula</mat-label>
            <input matInput formControlName="registration" />
          </mat-form-field>
          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>Data Contratação</mat-label>
            <input matInput [matDatepicker]="hiring" (focus)="openDatepicker('hiring')" formControlName="hiring" />
            <mat-datepicker-toggle matIconSuffix [for]="hiring"></mat-datepicker-toggle>
            <mat-datepicker #hiring></mat-datepicker>
          </mat-form-field>
          <div class="flex flex-col justify-center gap-4 items-start">
            <div>
              <mat-slide-toggle class="input-tg p-bottom-toggle " formControlName="isEmployee"
                (change)="checkSupplier()">
                <span>
                  {{
                  formEmployee.get('isEmployee')?.value
                  ? 'Funcionário'
                  : 'Prestador'
                  }}
                </span>
              </mat-slide-toggle>
            </div>
            <div>
              <mat-slide-toggle class="input-tg  p-bottom-toggle " formControlName="isSelfEmployed"
                (change)="checkSelfEmployed()">
                <span>
                  {{
                  formEmployee.get('isSelfEmployed')?.value
                  ? 'Autônomo'
                  : 'Tercerizado'
                  }}
                </span>
              </mat-slide-toggle>
            </div>
          </div>
        </div>

        <div class="flex justify-between gap-4 items-center">
          <mat-form-field class="input-tg w-5/12" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>

          <mat-form-field class="input-tg w-3/12" appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" />
          </mat-form-field>

          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>CPF</mat-label>
            <input matInput formControlName="cpf" [mask]="'999.999.999-99'" />
          </mat-form-field>

          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>Data nascimento</mat-label>
            <input matInput [matDatepicker]="birth" (focus)="openDatepicker('birth')" formControlName="birth"
              [max]="maxDate" />
            <mat-datepicker-toggle matIconSuffix [for]="birth"></mat-datepicker-toggle>
            <mat-datepicker #birth></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="flex justify-between items-center mt-3 -mx-2">
          <mat-form-field class="input-tg w-full px-2" appearance="outline">
            <mat-label>Fornecedor</mat-label>
            <input matInput formControlName="supplier" readonly />
          </mat-form-field>
        </div>

        <div class="mt-2">
          <mat-divider></mat-divider>
        </div>
        <h4>Endereço</h4>
        <div class="flex justify-between gap-4 items-center">
          <mat-form-field class="input-tg w-3/12" appearance="outline">
            <mat-label>Tipo endereço</mat-label>
            <mat-select formControlName="addressType">
              @for (type of listAddressType; track type) {
              <mat-option [value]="type.id">{{
                type.description
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex justify-between gap-4 items-center">
          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>CEP</mat-label>
            <input matInput (input)="getAddressByPostalCode()" (blur)="getAddressByPostalCode()"
              formControlName="postalCode" />
          </mat-form-field>

          <mat-form-field class="input-tg w-6/12" appearance="outline">
            <mat-label>Logradouro</mat-label>
            <input matInput formControlName="street" />
          </mat-form-field>

          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>Número</mat-label>
            <input matInput formControlName="number" />
          </mat-form-field>

          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>Bairro</mat-label>
            <input matInput formControlName="neighborhood" />
          </mat-form-field>
        </div>

        <div class="flex justify-between gap-4 items-center">
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Complemento</mat-label>
            <input matInput formControlName="complement" />
          </mat-form-field>

          <mat-form-field class="input-tg w-3/12" appearance="outline">
            <mat-label>Cidade</mat-label>
            <input matInput formControlName="city" />
          </mat-form-field>

          <mat-form-field class="input-tg w-3/12" appearance="outline">
            <mat-label>Estado</mat-label>
            <input matInput formControlName="state" />
          </mat-form-field>

          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>País</mat-label>
            <input matInput formControlName="country" />
          </mat-form-field>
        </div>
      </div>

      <div class="mt-1">
        <mat-divider></mat-divider>
      </div>
      <h4 class="mb-0">Contatos</h4>
      <div>
        <contact-client-edit [idPerson]="this.item.pessoaId" />
      </div>
      <div class="mt-1">
        <mat-divider></mat-divider>
      </div>
      <h4 class="">Habilitação</h4>
      <div class="flex justify-between gap-4 items-center">
        <mat-form-field class="input-tg w-3/12" appearance="outline">
          <mat-label>Categoria</mat-label>
          <mat-select formControlName="docCategory">
            @for (item of listCategory; track item) {
            <mat-option [value]="item.id">{{ item.description }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="input-tg w-7/12" appearance="outline">
          <mat-label>N° registro</mat-label>
          <input matInput formControlName="docRegistration" />
        </mat-form-field>
        <mat-form-field class="input-tg w-2/12" appearance="outline">
          <mat-label>Validade</mat-label>
          <input matInput [matDatepicker]="docValidity" (focus)="openDatepicker('validity')"
            formControlName="docValidity" [min]="minDate" />
          <mat-datepicker-toggle matIconSuffix [for]="docValidity"></mat-datepicker-toggle>
          <mat-datepicker #docValidity></mat-datepicker>
        </mat-form-field>
      </div>
      <div>
        <!--        <contact-client-edit [idPerson]="this.item.pessoaId" />-->
        <driver-upload-edit [idPerson]="this.item.pessoaId" />
      </div>
    </div>
    <div class="flex justify-end mt-3">
      <button mat-flat-button class="btn-tg w-1/5" [disabled]="!checkForm() || loading" (click)="editDriver()">
        @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
        Cadastrar
        }
      </button>
    </div>
  </mat-card>
</mat-card>